import { ConfirmDialog } from "components/ConfirmDialog";
import { useLogin } from "providers/Login";
import { useNotification } from "providers/Notification";
import { useState, useEffect } from "react";
import ApiKey from "./Types";

interface DeleteAPIKeyDialogProps {
    keyBeingDeleted: ApiKey | undefined
    onClose: (deleted: boolean) => void
}

function DeleteAPIKeyDialog(props: DeleteAPIKeyDialogProps) {
    const notification = useNotification();
    const login = useLogin();
    const req = login.GetAxios();

    const [loading, setLoading] = useState(false);
    const [apiKeyName, setApiKeyName] = useState("");

    useEffect(() => {
        setLoading(false);

        if (props.keyBeingDeleted !== undefined) {
            setApiKeyName(props.keyBeingDeleted.name);
        }
    }, [props.keyBeingDeleted]);

    const deleteAPIKeyConfirm = async () => {
        if (!req) {
            return; //not logged in, nothing to do
        }
        setLoading(true);

        try {
            await req.delete(`/api/auth/apikey/${props.keyBeingDeleted?.id}`);
            notification.Display({
                type: "success",
                title: "Success",
                message: "Api key deleted successfully",
            });
            props.onClose(true);
        } catch (err) {
            notification.Display({
                title: "Error",
                message: "Error deleting API Key",
                type: "error",
            });
            setLoading(false);
        }
    };

    return <ConfirmDialog
        open={props.keyBeingDeleted !== undefined}
        title="Delete API Key"
        message={`Are you sure you want to delete the API Key ${apiKeyName}?`}
        confirmLabel="Delete"
        loading={loading}
        onConfirm={() => deleteAPIKeyConfirm()}
        onCancel={() => props.onClose(false)}
    />;
}

export default DeleteAPIKeyDialog;